import React, { useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";
import {
  Button,
  Container,
  Modal,
  Pagination,
  Spinner,
  Table,
} from "react-bootstrap";
import search_icon from "../assets/search_icon.svg";
import "./Main.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort, faRefresh } from "@fortawesome/free-solid-svg-icons";
import SidebarContent from "./Sidebar";
import TableStatus from "./TableStatus";
import axiosInstance from "../utils/axiosInstance";

export default function Transactions() {
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [isSortFieldDBVisible, setisSortFieldDBVisible] = useState(false);
  const [SortFieldDB, setSortFieldDB] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [columns, setcolumns] = useState([]);
  const [sortOrder, setSortOrder] = useState(null);
  const [data, setdata] = useState(null);
  const [SelectedPage, setSelectedPage] = useState("All Records");
  const smsStatusOptions = ["SUCCESS", "FAILED", "NOT_SENT"];
  const paymentStatusOptions = ["Ongoing", "Completed", "Failed", "Cancelled"];
  // Define the columns to display in the table
  const tableColumns = [
    "paymentId",
    "merchantId",
    "merchant_txn",
    "amount",
    "customer_name",
    "PaymentStatus",
    "smsStatus",
    "PayoutStatus",
    "createdAt",
  ];

  const [smsStatusFilter, setSmsStatusFilter] = useState("");
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("");

  // NEW STATES
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const handlePageChange = (value) => {
    setPage(value);
  };

  const handleStartDateTimeChange = (e) => {
    setStartDateTime(e.target.value);
  };

  const handleEndDateTimeChange = (e) => {
    setEndDateTime(e.target.value);
  };
  const openModal = (transaction) => {
    setSelectedTransaction(transaction);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);
  // optional: autofocus when user clicks
  const handleFocus = (e) => {
    e.target.showPicker?.(); // modern browsers
  };
  const pageCount = Math.ceil(totalCount / pageSize);

  // New state for selected rows
  const [selectedRows, setSelectedRows] = useState([]);
  const [showSelectedModal, setShowSelectedModal] = useState(false);

  const toggleRowSelection = (transaction) => {
    const exists = selectedRows.find(
      (row) => row.paymentId === transaction.paymentId
    );
    if (exists) {
      setSelectedRows(
        selectedRows.filter((row) => row.paymentId !== transaction.paymentId)
      );
    } else {
      setSelectedRows([...selectedRows, transaction]);
    }
  };

  const handleShowSelected = () => {
    setShowSelectedModal(true);
  };
  const handleSubmitSelected = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      alert("No rows selected for payout.");
      return;
    }

    const paymentIds = selectedRows.map((row) => row.paymentId);

    // Optional: show a loading indicator

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_LINK}/v1/InitiatePayout`,
        { paymentIds }
      );

      const { updatedRows, skippedRows, message } = response.data;

      // Log server response
      console.log("Server message:", message);
      console.log("Updated rows:", updatedRows);
      if (skippedRows && skippedRows.length > 0) {
        console.warn("Skipped rows:", skippedRows);
        alert(
          `${skippedRows.length} row(s) were skipped: ` +
            skippedRows.map((r) => `${r.paymentId} (${r.reason})`).join(", ")
        );
      }

      // Update local state: clear selected rows and close modal
      setSelectedRows([]);
      setShowSelectedModal(false);

      // Optional: refresh table or UI if needed
      fetchData(); // assuming you have a function to reload payments
    } catch (error) {
      console.error("Error updating payout status:", error);

      // Show meaningful message
      const message =
        error.response?.data?.message ||
        "Failed to update payout status. Please try again.";
      alert(message);
    } finally {
    }
  };

  const fetchData = async (pagex2) => {
    try {
      setIsLoading(true);
      var pagex = pagex2 || SelectedPage;
      await axiosInstance({
        url: process.env.REACT_APP_API_LINK + `/v1/getTransactionsData`,
        method: "POST",
        responseType: "json",
        data: {
          PayoutStatus:
            pagex === "All Records"
              ? undefined // no filter, return all
              : pagex === "Payout Eligible"
              ? ["pending"]
              : pagex === "Payout Completed"
              ? ["completed"]
              : pagex === "Payout Failed"
              ? ["failed"]
              : undefined,

          smsStatus: smsStatusFilter || null,
          PaymentStatus:
            pagex === "Payout Eligible"
              ? ["completed"] // adjust to your DB values
              : paymentStatusFilter || null,

          sortField: SortFieldDB,
          searchValue: searchValue,
          sortOrder: !sortOrder ? "asc" : sortOrder,
          startDateTime: startDateTime || null,
          endDateTime: endDateTime || null,
          page: page,
        },
      }).then((response) => {
        if (response) {
          var datax = response.data.data;
          setdata(datax);
          console.log(datax);

          if (datax.length > 0) {
            setTotalCount(response.data.totalCount);
            setcolumns(Object.keys(datax[0]));
          }
        }
      });
    } catch (err) {
      console.log("error fetching ");
      alert("error fetching data");
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(SelectedPage);
  }, [
    SortFieldDB,
    searchValue,
    sortOrder,
    page,
    startDateTime,
    endDateTime,
    smsStatusFilter,
    paymentStatusFilter,
    SelectedPage,
  ]);

  const handleSort = (field) => {
    if (field === SortFieldDB) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortFieldDB(field);
      setSortOrder("asc");
    }
  };

  const getPageItems = () => {
    const items = [];
    items.push(
      <Pagination.Prev
        key="prev"
        onClick={() => page > 1 && handlePageChange(page - 1)}
        disabled={page <= 1}
      />
    );

    for (
      let i = Math.max(1, page - 4);
      i <= Math.min(pageCount, page + 5);
      i++
    ) {
      items.push(
        <Pagination.Item
          key={i}
          active={page === i}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    items.push(
      <Pagination.Next
        key="next"
        onClick={() => page < pageCount && handlePageChange(page + 1)}
        disabled={page >= pageCount}
      />
    );
    return items;
  };

  const handleClick = async (page) => {
    setPage(1);
    setSelectedPage(page);
    fetchData(page);
  };
  const NavV = () => {
    const navItems = [
      {
        label: "All Records",
      },
      {
        label: "Payout Eligible",
      },
      {
        label: "Payout Completed",
      },
      {
        label: "Payout Failed",
      },
    ];
    return (
      <>
        <p
          className="align-self-end"
          style={{
            padding: "2%",
            paddingLeft: 0,
            display: "flex",
            backgroundColor: "white",
            margin: 0,
            marginTop: "0rem",
            flexDirection: "row",
            alignItems: "center",

            // , marginBottom: 20
          }}
        >
          {"Home > "}
          <p
            className="align-self-end"
            style={{
              margin: 0,
              marginTop: "0rem",
              marginLeft: "0.51rem",
              fontWeight: "700",
            }}
          >
            {"Transactions"}
          </p>
        </p>
        <div
          className="align-self-end d-flex align-items-center"
          style={{ margin: 0, gap: 10 }}
        >
          {navItems.map(({ label }) => (
            <div
              key={label}
              className={
                SelectedPage === label ? "activeRecordx1" : "disabledRecordx1"
              }
              style={{ cursor: "pointer" }}
              onClick={() => handleClick(label)}
            >
              <p style={{ margin: 0 }}>{label}</p>
            </div>
          ))}
        </div>
        <br />
      </>
    );
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
      }}
    >
      <SidebarContent />
      <>
        {!isLoading ? (
          <Container
            fluid
            style={{
              padding: "1%",
              maxWidth: "85%",
            }}
          >
            {/* Search & Filters */}
            <NavV />

            <div
              className="d-flex flex-wrap"
              style={{
                display: "flex",
                alignItems: "stretch",
              }}
            >
              <div className="customx-input-group" style={{ maxWidth: 800 }}>
                <img
                  src={search_icon}
                  alt=""
                  width={40}
                  style={{ padding: 10 }}
                />
                <input
                  type="text"
                  className="customx-form-control"
                  style={{ minWidth: 400 }}
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="Search here"
                />
              </div>

              <button
                className="custButton"
                // className="custButton"
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  border: "none",
                }}
                onClick={() => {
                  setisSortFieldDBVisible(!isSortFieldDBVisible);
                }}
              >
                <p className="custButton-text">
                  {SortFieldDB ? SortFieldDB : "Select Sort"}
                </p>
                <FontAwesomeIcon icon={faSort} className="custButton-icon" />
                {isSortFieldDBVisible && (
                  <div className="calendar-container">
                    <div className="FilterDropDown-menu">
                      {columns.map((key) => (
                        <span
                          key={key}
                          className="FilterDropDown-item-text"
                          onClick={() => {
                            setSortFieldDB(key);
                          }}
                        >
                          {key}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </button>
              {/* Start DateTime */}
              <div
                style={{
                  marginRight: "20px",
                }}
              >
                <label>Start Date and Time:</label>
                <input
                  className="custButton"
                  type="datetime-local"
                  value={startDateTime}
                  style={{ width: "100%", maxWidth: "100%" }}
                  onChange={handleStartDateTimeChange}
                  onFocus={handleFocus}
                />
              </div>

              {/* End DateTime */}
              <div
                style={{
                  marginRight: "20px",
                }}
              >
                <label>End Date and Time:</label>
                <input
                  className="custButton"
                  type="datetime-local"
                  value={endDateTime}
                  style={{ width: "100%", maxWidth: "100%" }}
                  onChange={handleEndDateTimeChange}
                  onFocus={handleFocus}
                />
              </div>

              {/* SMS Status Filter */}
              <div style={{ marginRight: "20px" }}>
                <label>SMS Status:</label>
                <select
                  className="custButton"
                  value={smsStatusFilter}
                  onChange={(e) => {
                    setSmsStatusFilter(e.target.value);
                  }}
                >
                  <option value="">All</option>
                  {smsStatusOptions.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>

              {/* Payment Status Filter */}
              <div style={{ marginRight: "20px" }}>
                <label>Payment Status:</label>
                <select
                  className="custButton"
                  value={paymentStatusFilter}
                  onChange={(e) => {
                    setPaymentStatusFilter(e.target.value);
                  }}
                >
                  <option value="">All</option>
                  {paymentStatusOptions.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>
              <div className="custButton" onClick={() => fetchData()}>
                <p className="custButton-text">Refresh</p>
                <FontAwesomeIcon icon={faRefresh} className="custButton-icon" />
              </div>
              {SelectedPage === "Payout Eligible" &&
                selectedRows.length > 0 && (
                  <Button
                    style={{ marginTop: 10 }}
                    onClick={handleShowSelected}
                  >
                    Show Selected ({selectedRows.length})
                  </Button>
                )}
            </div>

            {/* Table */}
            {data?.length > 0 ? (
              <div style={{ overflowX: "auto", marginTop: 25 }}>
                <Table hover responsive>
                  <thead>
                    <tr style={{ color: "#809FB8", fontWeight: "600" }}>
                      {SelectedPage === "Payout Eligible" && <th>Select</th>}
                      {tableColumns.map((column) => (
                        <th
                          key={column}
                          onClick={() => handleSort(column)}
                          style={{ cursor: "pointer" }}
                        >
                          {column}
                        </th>
                      ))}
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        {SelectedPage === "Payout Eligible" && (
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedRows.some(
                                (row) => row.paymentId === item.paymentId
                              )}
                              onChange={() => toggleRowSelection(item)}
                            />
                          </td>
                        )}
                        {tableColumns.map((field, fieldindex) =>
                          [
                            "validated",
                            "payoutstatus",
                            "smsstatus",
                            "paymentstatus",
                          ].includes(field.toLowerCase()) ? (
                            <td key={fieldindex}>
                              <TableStatus text={item[field] + ""} />
                            </td>
                          ) : (
                            <td key={fieldindex}>{item[field] + ""}</td>
                          )
                        )}
                        <td>
                          <Button size="sm" onClick={() => openModal(item)}>
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Pagination style={{ float: "right" }}>
                  <Pagination.First onClick={() => handlePageChange(1)} />
                  {getPageItems()}
                  <Pagination.Last
                    onClick={() => handlePageChange(pageCount)}
                  />
                </Pagination>
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignSelf: "center",
                    alignItems: "center",
                    height: "70vh",
                    backgroundColor: "white",
                  }}
                >
                  <h3>No data found</h3>
                </div>
              </>
            )}

            {/* Side Modal */}

            <Modal
              show={showSelectedModal}
              onHide={() => setShowSelectedModal(false)}
              size="lg"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Selected Transactions</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedRows.length > 0 ? (
                  selectedRows.map((row) => (
                    <div key={row.paymentId}>
                      <strong>{row.paymentId}</strong> - {row.customer_name} -{" "}
                      {row.amount}
                    </div>
                  ))
                ) : (
                  <p>No rows selected</p>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowSelectedModal(false)}
                >
                  Close
                </Button>
                <Button variant="primary" onClick={handleSubmitSelected}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={showModal} onHide={closeModal} size="lg" centered>
              <Modal.Header closeButton>
                <Modal.Title>Transaction Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedTransaction ? (
                  <div>
                    {Object.entries(selectedTransaction).map(([key, value]) => (
                      <div key={key} style={{ marginBottom: "0.5rem" }}>
                        <strong>{key}:</strong>{" "}
                        {typeof value === "object"
                          ? JSON.stringify(value, null, 2)
                          : value + ""}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No data available</p>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </Container>
        ) : isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignSelf: "center",
              alignItems: "center",
              height: "70vh",
              width: "100%",
              backgroundColor: "white",
            }}
          >
            <Spinner animation="border" />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "70vh",
            }}
          >
            <h3>No data found</h3>
          </div>
        )}
      </>
    </div>
  );
}
